export default __webpack_public_path__ + "media/images/obstacles-icon-de6f2c65ce7f327f233981850f12d110.svg";